import '@css/main.scss'
import '@js/bootstrap'

import { Header } from '@js/components/Header'
import { TopHeader } from '@js/components/TopHeader'
import { Slider } from '@js/components/Slider'
import { Archive } from '@js/components/Archive'
// import { Mask } from '@js/animations/Mask'
import { Stagger } from '@js/animations/Stagger'
import { Wipe } from '@js/animations/Wipe'
import { Scroll } from '@js/animations/Scroll'
// import { Translate } from '@js/animations/Translate'
import { Shape } from '@js/animations/Shape'
import { Zoom } from '@js/animations/Zoom'
import { Parallax } from '@js/animations/Parallax'
import { Map } from '@js/components/Map'
import { Timeline } from '@js/components/Timeline'
import { Tabs } from '@js/components/Tabs'
import { ContactMaps } from '@js/components/ContactMaps'
import { CarSlider } from '@js/components/CarSlider'
import { TabNewVehicles } from '@js/components/TabNewVehicles'
import { UsedCarsArchive } from '@js/components/UsedCarsArchive'
import { SingleCar } from '@js/components/SingleCar'
import { Animations } from '@js/components/Animations'
import { AkyosAttributeLoader} from "akyos-animation";

window.onload = () => {

  const animations = [
    // Mask,
    Stagger,
    Wipe,
    Scroll,
    // Translate,
    Shape,
    Zoom,
    Parallax,
  ]

  animations.forEach(animation => {
    new animation()
  })

  new Header()
  new TopHeader()
  new Archive()
  new Slider()
  new Map()
  new Timeline()
  new Tabs()
  new ContactMaps()
  new CarSlider()
  new TabNewVehicles()
  new UsedCarsArchive()
  new SingleCar()
  new Animations()
  // new AkyosAttributeLoader()
}
